import React, { useCallback } from "react";
import { useState } from "react";
import { Trash } from "react-bootstrap-icons";
import ConfirmDialog from "./ConfirmDialog";

const SavedLocComponent = ({ savedLocs, setMousedLoc, deleteLoc }) => {
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [selectedKey, setSelectedKey] = useState();

  const handleTrashIconClick = useCallback(
    (key) => {
      setSelectedKey(key);
      setIsOpenConfirm(true);
    },
    [setSelectedKey, setIsOpenConfirm]
  );

  const handleConfClose = useCallback(() => {
    setSelectedKey(undefined);
    setIsOpenConfirm(false);
  }, [setSelectedKey, setIsOpenConfirm]);

  const handleConfSubmit = useCallback(() => {
    deleteLoc(selectedKey);
    setSelectedKey(undefined);
    setIsOpenConfirm(false);
  }, [selectedKey, setSelectedKey, setIsOpenConfirm]);

  return (
    <div
      className="card clearfix"
      style={{
        overflow: "scroll",
        overflowX: "hidden",
      }}
    >
      <h2 className="clearfix">Saved Locations</h2>
      <div>
        {Object.keys(savedLocs).map((key, idx) => (
          <div
            className="card-2 clearfix"
            key={key}
            style={{
              padding: "3px 3px",
              display: "flex",
              flexDirection: "row",
              marginBottom: "3px",
            }}
            onMouseEnter={() => {
              if (setMousedLoc) setMousedLoc(key);
            }}
            onMouseLeave={() => {
              if (setMousedLoc) setMousedLoc(null);
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                paddingLeft: "10px",
              }}
            >
              {key}
            </div>
            <Trash
              onClick={() => handleTrashIconClick(key)}
              style={{
                width: "10%",
              }}
            />
          </div>
        ))}
      </div>
      {isOpenConfirm && (
        <ConfirmDialog
          msg={`Delete gps coordinate data for anchor ${selectedKey}?`}
          isOpenConfirm={isOpenConfirm}
          handleClose={handleConfClose}
          handleSubmit={handleConfSubmit}
        />
      )}
    </div>
  );
};

export default SavedLocComponent;
